import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CalendarDays } from "lucide-react";

const DAY_LABELS = ["M", "T", "W", "T", "F", "S", "S"];

export default function StreakCalendar() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/stats/activity?weeks=12").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  return (
    <div className="rounded-3xl border border-brand-line bg-white p-6" data-testid="streak-calendar">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <CalendarDays className="w-5 h-5 text-brand" />
          <h4 className="font-display text-xl text-brand-ink">Your listening calendar</h4>
        </div>
        <span className="text-sm text-brand-muted">{data?.total_active_days ?? 0} active days</span>
      </div>

      <div className="flex gap-3">
        {/* day labels */}
        <div className="flex flex-col gap-1 pt-0.5">
          {DAY_LABELS.map((d, i) => (
            <div key={i} className="h-4 w-4 text-[10px] text-brand-muted flex items-center justify-center">{d}</div>
          ))}
        </div>
        {/* weeks as columns */}
        <div className="flex gap-1 overflow-x-auto scrollbar-thin pb-1">
          {(data?.weeks || Array.from({ length: 12 }).map(() => ({ days: Array.from({ length: 7 }).map(() => ({})) }))).map((w, wi) => (
            <div key={wi} className="flex flex-col gap-1">
              {w.days.map((day, di) => {
                let cls = "bg-brand-sidebar";
                if (day.active) cls = "bg-brand";
                else if (day.future) cls = "bg-brand-sidebar/40";
                return (
                  <div
                    key={di}
                    title={day.date ? `${day.date}${day.active ? " · listened" : ""}` : ""}
                    className={`h-4 w-4 rounded-[3px] ${cls} ${day.is_today ? "ring-2 ring-brand-dough ring-offset-1" : ""}`}
                    data-testid={day.active ? "calendar-active-day" : undefined}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-end gap-2 mt-3 text-xs text-brand-muted">
        <span className="h-3 w-3 rounded-[3px] bg-brand-sidebar" />
        <span>Not listened</span>
        <span className="h-3 w-3 rounded-[3px] bg-brand ml-3" />
        <span>Listened</span>
        <span className="h-3 w-3 rounded-[3px] bg-brand ring-2 ring-brand-dough ring-offset-1 ml-3" />
        <span>Today</span>
      </div>
    </div>
  );
}
